
export class CompanyModuleIdRequest {
    companyId: number;
    moduleId: number;

    /**
     * 
     * @param companyId 
     * @param moduleId 
     */
    constructor(companyId: number, moduleId: number) {
        this.companyId = companyId;
        this.moduleId = moduleId;
    }
}